import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Japan from "./pages/Japan";
import Pilot from "./pages/Pilot";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/about_us.html" element={<Navigate to="/about-us" replace />} />
        <Route path="/japan" element={<Japan />} />
        <Route path="/japan.html" element={<Navigate to="/japan" replace />} />
        <Route path="/pilot" element={<Pilot />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
